import cz from '../csCZ/help';

const de: typeof cz = {
	search_title: 'Hilfe bei der suche nach informationen im Digitalen archiv',
	search_text_prefix:
		'Durch die Applikation können Sie nach Informationen über Personen und Häuser im ',
	search_text_bold: 'Digitalen Archiv der Stadt Brno',
	search_text_suffix:
		' anhand festgelegter Kriterien suchen. Die Suche ist auf zwei Ebenen möglich, auf denen der Benutzer nach Informationen suchen kann, die in diesem Archiv gespeichert sind.',
	basic_search_title: 'Einfache Suche',
	basic_search_text: 'Ermöglicht die Suche anhand der folgenden Metadaten:',
	metadata: {
		year: 'Volkszählungsjahrgang',
		street: 'Straßenname',
		house: 'Hausnummer',
		surname: 'Nachname',
		firstname: 'Name',
	},
	search_in_connected_municipalities_title: 'Suche in verbundenen Gemeinden',
	search_in_connected_municipalities_prefix:
		'Bei der Suche in Gemeinden, die erst 1919 mit Brünn verbunden waren, muss der tschechishe Name der Gemeinde in dem Suchfeld im Abschnitt ',
	search_in_connected_municipalities_bold: 'Straßenname',
	search_in_connected_municipalities_suffix:
		' eingegeben werden. Nachdem Sie den tschechischen Namen des Dorfes eingegeben haben (z. B. Královo Pole, Husovice usw.), werden die entsprechenden Straßen im Menü nach dem Bindestrich angezeigt. Da in diesen Gemeinden keine Register verfügbar waren, ist es nicht möglich, nach Vor- und Nachnamen zu suchen.',
	advanced_search_title: 'Erweiterte Suche',
	advanced_search_text:
		'Das erweiterte Suchsystem richtet sich an Archivare und Forscher.',
	advanced_search_criteria: {
		text: 'Folgende Kriterien stehen zur Verfügung:',
		volume: 'Band – eine Bezeichnung des einzelnen Bandes vom Namensregister',
		page_number:
			'Seitennummer – eine Seitennummer im Buch, wo sich der gesuchte Name vorfindet',
		inventory_number:
			'Inventarisierungsnummer – eine einmalige Bezeichnung für jedes Buch sowohl aus Namensregister, als auch aus Volkszählungsoperaten',
	},
	search_results_title: 'Suchergebnisse',
	search_results_text:
		'Die übersichtliche Tabelle zeigt die Einträge, die den angegebenen Suchkriterien entsprechen. In jeder Zeile der Tabelle werden nach spezifischen Anforderungen das Volkszählungsjahr, der Straßenname, die Hausnummer, das Bild der Operaten, der Nachname, der Vorname und die Namensregisterseite nacheinander aufgelistet. Klicken Sie auf die Lupe, um die konkrete digitalisierte Abbildung der Archivalien anzuzeigen.',
	archive_view_title: 'Abbildung der Archivalien',
	archive_view_text:
		'In der Kopfzeile der angezeigten Archivalien finden Sie im horizontalen Menü Informationen zu der aktuell ausgewählten Person. Das Browser-Menü enthält Funktionen zum Vergrößern / Verkleinern, zur Abbildung der Achivalien, zum Drehen um 90 Grad, zum Zurückkehren zum vorherigen Bildschirm und zum Scrollen durch die Seiten des einzelnen Archivs.',
};

export default de;
